import * as React from 'react'

import { inject, observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import { getTransitionPath } from '~/client/src/shared/constants/commonRoutes'

import DesktopInitialState from '../../../stores/DesktopInitialState'
import NavBarStore from '../NavBar.store'

// localization: no display text to translate

interface ISettingsItemProps {
  isHovering?: boolean
  isUnclickable?: boolean
  icon?: React.ReactNode
  route?: string
  routeLabel?: string
  navBarStore: NavBarStore
  onClickHandler?: (event: React.SyntheticEvent) => void
  isActive?: boolean
  omitIfActive?: boolean

  state?: DesktopInitialState
  className?: string
  testId?: string
}

@inject('state')
@observer
export default class SettingsItem extends React.Component<ISettingsItemProps> {
  public static defaultProps = {
    isHovering: true,
  }

  public render() {
    const {
      isHovering,
      isUnclickable,
      onClickHandler,
      routeLabel,
      icon,
      children,
      isActive,
      className,
      testId,
    } = this.props

    const active = isActive || this.isActive
    if (this.props.omitIfActive && active) {
      return null
    }

    return (
      <div
        className={classList({
          'settings-item nowrap h40 my2': true,
          'row x-center': !!icon,
          nohover: !isHovering,
          active,
          'unclickable-element': isUnclickable,
          [className]: !!className,
        })}
        onClick={onClickHandler || this.onClickDefault}
        data-testid={testId}
      >
        <div className="col icon-wrapper mw30 no-grow">{icon}</div>
        <div className="col">
          {children}
          {routeLabel}
        </div>
      </div>
    )
  }

  private onClickDefault = (evt: React.SyntheticEvent) => {
    evt.stopPropagation()

    this.props.navBarStore.displayView(this.props.route)
  }

  private get isActive(): boolean {
    const { route, navBarStore, state } = this.props
    const { location } = navBarStore

    return (
      route &&
      location.pathname.includes(
        getTransitionPath(route, state.activeOrInitProjectCode),
      )
    )
  }
}
